// extracted by mini-css-extract-plugin
module.exports = {"descriptionList":"About-descriptionList-qNyt5 DescriptionList-descriptionList-2v6H6"};